import { Injectable } from '@angular/core';
import { AjaxService } from '../services/ajax.service';

@Injectable()
export class StudyImageRequestService {
    constructor(private ajaxService: AjaxService) {}

    getImageUrl(studyId, contentType) {
        return `${this.ajaxService.apiUrl}/standalone/images/${studyId}?image_type=${contentType}`;
    }
}


// WEBPACK FOOTER //
// ./src/app/services/study-image-request.service.ts